"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionLoadOriginalData = exports.FunctionInitalData = exports.FunctionLoadData = exports.FunctionCoreinitalValueThirdStepObject = exports.FunctionCoreinitalValueThirdStep = exports.FunctionCoreinitalValueSecondStepObject = exports.FunctionCoreinitalValueSecondStepSpacial = exports.FunctionCoreinitalValueSecondStep = exports.FunctionCoreinitalValueFirstStep = exports.FunctionCoreLoadDataThirdStepObject = exports.FunctionCoreLoadDataThirdStep = exports.FunctionCoreLoadDataSecondStepObject = exports.FunctionCoreLoadDataSecondStepSpacial = exports.FunctionCoreLoadDataSecondStep = exports.FunctionCoreLoadDataFirstStep = exports.FunctionLoadDataTypeSelect = void 0;
const __1 = require("../../..");
const type_1 = require("../../../type");
const FunctionLoadDataTypeSelect = (props, value) => {
    const self = props.options.find((i) => i.value === value);
    if (self) {
        props.setValue(self);
    }
    else {
        props.setValue(value);
    }
};
exports.FunctionLoadDataTypeSelect = FunctionLoadDataTypeSelect;
const FunctionCoreLoadDataFirstStep = (props) => {
    try {
        const value = (0, __1.FunctionCloneDeep)(props.loadData[props.name]);
        // console.log("PROPS 1 : ", { props, value });
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreLoadDataFirstStep = FunctionCoreLoadDataFirstStep;
const FunctionCoreLoadDataSecondStep = (props) => {
    try {
        // console.log("PROPS 2 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.loadData[props.grandParentKey][props.parentIndex][props.parentKey][props.fieldIndex][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreLoadDataSecondStep = FunctionCoreLoadDataSecondStep;
const FunctionCoreLoadDataSecondStepSpacial = (props) => {
    try {
        // console.log("PROPS 2 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.loadData[props.grandParentKey][props.parentKey][props.fieldIndex][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreLoadDataSecondStepSpacial = FunctionCoreLoadDataSecondStepSpacial;
const FunctionCoreLoadDataSecondStepObject = (props) => {
    try {
        if (props.parentIndex >= 0) {
            const value = (0, __1.FunctionCloneDeep)(props.loadData[props.grandParentKey][props.parentIndex][props.parentKey][props.name]);
            if (props.type === type_1.TYPE_SELECT) {
                (0, exports.FunctionLoadDataTypeSelect)(props, value);
            }
            else {
                props.setValue(value);
            }
        }
        else {
            const value = (0, __1.FunctionCloneDeep)(props.loadData[props.grandParentKey][props.parentKey][props.name]);
            if (props.type === type_1.TYPE_SELECT) {
                (0, exports.FunctionLoadDataTypeSelect)(props, value);
            }
            else {
                props.setValue(value);
            }
        }
    }
    catch (error) { }
};
exports.FunctionCoreLoadDataSecondStepObject = FunctionCoreLoadDataSecondStepObject;
const FunctionCoreLoadDataThirdStep = (props) => {
    try {
        // console.log("PROPS 3 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.loadData[props.parentKey][props.fieldIndex][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreLoadDataThirdStep = FunctionCoreLoadDataThirdStep;
const FunctionCoreLoadDataThirdStepObject = (props) => {
    try {
        // console.log("PROPS 3 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.loadData[props.parentKey][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreLoadDataThirdStepObject = FunctionCoreLoadDataThirdStepObject;
const FunctionCoreinitalValueFirstStep = (props) => {
    try {
        const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.name]);
        // console.log("PROPS 1 : ", { props, value });
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreinitalValueFirstStep = FunctionCoreinitalValueFirstStep;
const FunctionCoreinitalValueSecondStep = (props) => {
    try {
        // console.log("PROPS 2 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.grandParentKey][props.parentIndex][props.parentKey][props.fieldIndex][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreinitalValueSecondStep = FunctionCoreinitalValueSecondStep;
const FunctionCoreinitalValueSecondStepSpacial = (props) => {
    try {
        // console.log("PROPS 2 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.grandParentKey][props.parentKey][props.fieldIndex][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreinitalValueSecondStepSpacial = FunctionCoreinitalValueSecondStepSpacial;
const FunctionCoreinitalValueSecondStepObject = (props) => {
    try {
        if (props.parentIndex >= 0) {
            const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.grandParentKey][props.parentIndex][props.parentKey][props.name]);
            if (props.type === type_1.TYPE_SELECT) {
                (0, exports.FunctionLoadDataTypeSelect)(props, value);
            }
            else {
                props.setValue(value);
            }
        }
        else {
            const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.grandParentKey][props.parentKey][props.name]);
            if (props.type === type_1.TYPE_SELECT) {
                (0, exports.FunctionLoadDataTypeSelect)(props, value);
            }
            else {
                props.setValue(value);
            }
        }
    }
    catch (error) { }
};
exports.FunctionCoreinitalValueSecondStepObject = FunctionCoreinitalValueSecondStepObject;
const FunctionCoreinitalValueThirdStep = (props) => {
    try {
        // console.log("PROPS 3 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.parentKey][props.fieldIndex][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreinitalValueThirdStep = FunctionCoreinitalValueThirdStep;
const FunctionCoreinitalValueThirdStepObject = (props) => {
    try {
        // console.log("PROPS 3 : ", props);
        const value = (0, __1.FunctionCloneDeep)(props.initalValue[props.parentKey][props.name]);
        if (props.type === type_1.TYPE_SELECT) {
            (0, exports.FunctionLoadDataTypeSelect)(props, value);
        }
        else {
            props.setValue(value);
        }
    }
    catch (error) { }
};
exports.FunctionCoreinitalValueThirdStepObject = FunctionCoreinitalValueThirdStepObject;
const FunctionLoadData = (props) => {
    var _a, _b;
    // console.log("FunctionLoadData", {
    //   props,
    //   name: props.name,
    // });
    if (props.loadData && props.name) {
        try {
            if (props.parentKey &&
                props.fieldIndex >= 0 &&
                ((_a = props.loadData[props.parentKey]) === null || _a === void 0 ? void 0 : _a.length) - 1 >= props.fieldIndex &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0) {
                // console.log("IN 1", props.name);
                (0, exports.FunctionCoreLoadDataThirdStep)(props);
            }
            else if (props.parentKey &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0 &&
                props.childType === type_1.TYPE_OBJECT) {
                // console.log("IN 2", props.name);
                (0, exports.FunctionCoreLoadDataThirdStepObject)(props);
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                props.parentIndex === -1) {
                // console.log("IN 5", { name: props.name, props });
                (0, exports.FunctionCoreLoadDataSecondStepSpacial)(props);
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                ((_b = props.loadData[props.grandParentKey][props.parentIndex][props.parentKey]) === null || _b === void 0 ? void 0 : _b.length) -
                    1 >=
                    props.fieldIndex &&
                props.childType === type_1.TYPE_ARRAY) {
                // console.log("IN 3", props.name);
                (0, exports.FunctionCoreLoadDataSecondStep)(props);
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.grandParentKey !== props.parentKey &&
                props.childType === type_1.TYPE_OBJECT) {
                // console.log("IN 4", props.name);
                (0, exports.FunctionCoreLoadDataSecondStepObject)(props);
            }
            else if (props.loadData[props.name] ||
                props.loadData[props.name] === 0) {
                // console.log("IN 6", props.name);
                (0, exports.FunctionCoreLoadDataFirstStep)(props);
            }
            else {
                // console.log("IN 7", props.name);
                return;
            }
        }
        catch (error) {
            // console.log("IN ERROR", { name: props.name, props, error });
            return;
        }
    }
    else {
        // console.log("OUT", props.name);
        return;
    }
    return;
};
exports.FunctionLoadData = FunctionLoadData;
const FunctionInitalData = (props) => {
    var _a, _b;
    // setTimeout(() => {
    if ((props.loadData && props.name) || (props.initalValue && props.name)) {
        try {
            if (props.parentKey &&
                props.fieldIndex >= 0 &&
                ((_a = props.initalValue[props.parentKey]) === null || _a === void 0 ? void 0 : _a.length) - 1 >= props.fieldIndex &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0) {
                (0, exports.FunctionCoreinitalValueThirdStep)(props);
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                ((_b = props.initalValue[props.grandParentKey][props.parentIndex][props.parentKey]) === null || _b === void 0 ? void 0 : _b.length) -
                    1 >=
                    props.fieldIndex) {
                (0, exports.FunctionCoreinitalValueSecondStep)(props);
            }
            else if (props.initalValue[props.name]) {
                (0, exports.FunctionCoreinitalValueFirstStep)(props);
            }
            else {
                return;
            }
        }
        catch (error) {
            if (props.initalValue[props.name]) {
                (0, exports.FunctionCoreinitalValueFirstStep)(props);
            }
            return;
        }
    }
    else {
        return;
    }
    return;
    // }, 200);
};
exports.FunctionInitalData = FunctionInitalData;
// export const FunctionInitalData = (props) => {
//   // setTimeout(() => {
//   if (props.initalValue && props.name) {
//     try {
//       if (
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.initalValue[props.parentKey]?.length - 1 >= props.fieldIndex &&
//         props.grandParentKey === props.parentKey &&
//         props.grandParentIndex >= 0
//       ) {
//         console.log("IN 1", props.name);
//         FunctionCoreinitalValueThirdStep(props);
//       } else if (
//         props.parentKey &&
//         props.grandParentKey === props.parentKey &&
//         props.grandParentIndex >= 0 &&
//         props.childType === TYPE_OBJECT
//       ) {
//         console.log("IN 2", props.name);
//         FunctionCoreinitalValueThirdStepObject(props);
//       } else if (
//         props.grandParentIndex >= 0 &&
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.grandParentKey !== props.parentKey &&
//         props.parentIndex === -1
//       ) {
//         console.log("IN 5", { name: props.name, props });
//         FunctionCoreinitalValueSecondStepSpacial(props);
//       } else if (
//         props.grandParentIndex >= 0 &&
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.grandParentKey !== props.parentKey &&
//         props.initalValue[props.grandParentKey][props.parentIndex][
//           props.parentKey
//         ]?.length -
//           1 >=
//           props.fieldIndex &&
//         props.childType === TYPE_ARRAY
//       ) {
//         console.log("IN 3", props.name);
//         FunctionCoreinitalValueSecondStep(props);
//       } else if (
//         props.grandParentIndex >= 0 &&
//         props.parentKey &&
//         props.grandParentKey !== props.parentKey &&
//         props.childType === TYPE_OBJECT
//       ) {
//         console.log("IN 4", props.name);
//         FunctionCoreinitalValueSecondStepObject(props);
//       } else if (props.initalValue[props.name]) {
//         console.log("IN 6", props.name);
//         FunctionCoreinitalValueFirstStep(props);
//       } else {
//         console.log("IN 7", props.name);
//         return;
//       }
//     } catch (error) {
//       console.log("IN ERROR", { name: props.name, props, error });
//       return;
//     }
//   } else {
//     console.log("OUT", props.name);
//     return;
//   }
//   return;
//   // }, 200);
// };
// export const FunctionLoadOriginalData = (props) => {
//   if (props.loadData || props.initalValue) {
//     try {
//       if (
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.loadData[props.parentKey]?.length - 1 >= props.fieldIndex &&
//         props.grandParentKey === props.parentKey &&
//         props.grandParentIndex >= 0
//       ) {
//         return props.loadData[props.parentKey][props.fieldIndex];
//       } else if (
//         props.grandParentIndex >= 0 &&
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.grandParentKey !== props.parentKey &&
//         props.loadData[props.grandParentKey][props.parentIndex][props.parentKey]
//           ?.length -
//           1 >=
//           props.fieldIndex
//       ) {
//         return props.loadData[props.grandParentKey][props.parentIndex][
//           props.parentKey
//         ][props.fieldIndex];
//       } else if (
//         props.loadData[props.name] ||
//         props.loadData[props.name] === 0
//       ) {
//         return props.loadData;
//       } else if (
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.initalValue[props.parentKey]?.length - 1 >= props.fieldIndex &&
//         props.grandParentKey === props.parentKey &&
//         props.grandParentIndex >= 0
//       ) {
//         return props.initalValue[props.parentKey][props.fieldIndex];
//       } else if (
//         props.grandParentIndex >= 0 &&
//         props.parentKey &&
//         props.fieldIndex >= 0 &&
//         props.grandParentKey !== props.parentKey &&
//         props.initalValue[props.grandParentKey][props.parentIndex][
//           props.parentKey
//         ]?.length -
//           1 >=
//           props.fieldIndex
//       ) {
//         return props.initalValue[props.grandParentKey][props.parentIndex][
//           props.parentKey
//         ][props.fieldIndex];
//       } else if (props.initalValue[props.name]) {
//         return props.initalValue;
//       } else {
//         return "No Data";
//       }
//     } catch (error) {
//       return;
//     }
//   } else {
//     return;
//   }
// };
const FunctionLoadOriginalData = (props) => {
    var _a, _b, _c, _d;
    if (props.loadData || props.initalValue) {
        try {
            if (props.parentKey &&
                props.fieldIndex >= 0 &&
                ((_a = props.loadData[props.parentKey]) === null || _a === void 0 ? void 0 : _a.length) - 1 >= props.fieldIndex &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0) {
                return props.loadData[props.parentKey][props.fieldIndex];
            }
            else if (props.parentKey &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0 &&
                props.childType === type_1.TYPE_OBJECT) {
                return props.loadData[props.parentKey];
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                props.parentIndex === -1) {
                return props.loadData[props.grandParentKey][props.parentKey];
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                ((_b = props.loadData[props.grandParentKey][props.parentIndex][props.parentKey]) === null || _b === void 0 ? void 0 : _b.length) -
                    1 >=
                    props.fieldIndex &&
                props.childType === type_1.TYPE_ARRAY) {
                return props.loadData[props.grandParentKey][props.parentIndex][props.parentKey][props.fieldIndex];
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.grandParentKey !== props.parentKey &&
                props.childType === type_1.TYPE_OBJECT) {
                return props.loadData[props.grandParentKey][props.parentIndex];
            }
            else if (props.loadData[props.name] ||
                props.loadData[props.name] === 0) {
                return props.loadData;
            }
            else if (props.parentKey &&
                props.fieldIndex >= 0 &&
                ((_c = props.initalValue[props.parentKey]) === null || _c === void 0 ? void 0 : _c.length) - 1 >= props.fieldIndex &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0) {
                return props.initalValue[props.parentKey][props.fieldIndex];
            }
            else if (props.parentKey &&
                props.grandParentKey === props.parentKey &&
                props.grandParentIndex >= 0 &&
                props.childType === type_1.TYPE_OBJECT) {
                return props.initalValue[props.parentKey];
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                props.parentIndex === -1) {
                return props.initalValue[props.grandParentKey][props.parentKey];
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.fieldIndex >= 0 &&
                props.grandParentKey !== props.parentKey &&
                ((_d = props.initalValue[props.grandParentKey][props.parentIndex][props.parentKey]) === null || _d === void 0 ? void 0 : _d.length) -
                    1 >=
                    props.fieldIndex &&
                props.childType === type_1.TYPE_ARRAY) {
                return props.initalValue[props.grandParentKey][props.parentIndex][props.parentKey][props.fieldIndex];
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.grandParentKey !== props.parentKey &&
                props.childType === type_1.TYPE_OBJECT) {
                return props.initalValue[props.grandParentKey][props.parentIndex];
            }
            if (props.initalValue[props.name]) {
                return props.initalValue;
            }
            else {
                return "No Data";
            }
        }
        catch (error) {
            return;
        }
    }
    else {
        return;
    }
};
exports.FunctionLoadOriginalData = FunctionLoadOriginalData;
